<div class="practice-header" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <div class="breadcrumb-container">
      <qai-breadcrumb-list
        [items]="getBreadcrumbItems()"
      ></qai-breadcrumb-list>
    </div>
    
    <span class="practice-heading">{{ moduleStats?.name }}</span>
  
    <div class="info-container">
      <div class="call-type-container">
        <qai-label [kind]="'secondary'" [size]="'small'" [weight]="'bold'">
          <qai-icon kind="repeat" qaiSlot="start" />
          {{ 'reportingV2.PRACTICE_LABEL' | transloco }}
        </qai-label>
      </div>
      <div class="date-range-container" *ngIf="formattedStartDate || formattedEndDate">
        <qai-badge
          [shape]="'rectangle'"
          [kind]="'gray'"
          [label]="(formattedStartDate && formattedEndDate) ? (formattedStartDate + ' - ' + formattedEndDate) : (formattedStartDate || formattedEndDate)"
          class="date-badge">
        </qai-badge>
      </div>
    </div>
    
    <div class="team-selector-container" *ngIf="searchOptions.length > 1">
      <qai-label class="selector-label" kind="secondary" size="small" weight="regular">
        {{ 'reportingV2.TEAMS' | transloco }}
      </qai-label>
        <qai-multiselect
          #multiselect
          [options]="searchOptions"
          [placeholder]="'reportingV2.SEARCH_TEAMS' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [startIcon]="'search'"
          (valueChange)="onTeamChange($event)"
          [value]="selectedTeams"
          [persistSearch]="true"
          [clearButton]="clearOption"
          [selectionDisplayMode]="'single-row-truncated'"
          [visibleOptionsSelectionMode]="visibleOptionsMode"
          >
        </qai-multiselect>
    </div>
  </qai-inner-wrap>
</div>

